export enum ADMIN_SUPPORTER {
  REQUEST = 'ADMIN_SUPPORTER_REQUEST',
  SUCCESS = 'ADMIN_SUPPORTER_SUCCESS',
  FAILURE = 'ADMIN_SUPPORTER_FAILURE'
}
